import React from "react";
import { observer } from "mobx-react";
import { QueryPatternViewStore } from "../../store";
import { QueryPatternViewForm } from "./QueryPatternViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type QueryPatternViewProps = {
  queryPatternViewStore: QueryPatternViewStore;
};

export const QueryPatternView: React.FC<QueryPatternViewProps> = observer(
  ({ queryPatternViewStore }) => {
    return (
      <div>
        <QueryPatternViewForm
          name={queryPatternViewStore.nameValue}
          pattern={queryPatternViewStore.patternValue}
          pathTypeOptions={queryPatternViewStore.getPathTypeOptions()}
          pathType={queryPatternViewStore.pathTypeValue}
          variables={queryPatternViewStore.variablesValue}
          toolTemplate={queryPatternViewStore.toolTemplateValue}
          argsTemplate={queryPatternViewStore.argsTemplateValue}
          variations={queryPatternViewStore.variationsValue}
          exampleInstantiation={queryPatternViewStore.exampleInstantiationValue}
          sourceOptions={queryPatternViewStore.getSourceOptions()}
          source={queryPatternViewStore.sourceValue}
          qualityScore={queryPatternViewStore.qualityScoreValue}
          usageCount={queryPatternViewStore.usageCountValue}
          isActive={queryPatternViewStore.isActiveValue}
          notes={queryPatternViewStore.notesValue}
          onPrint={(handlePrint: () => void) =>
            queryPatternViewStore.printQueryPattern(handlePrint)
          }
          onCancel={() => queryPatternViewStore.cancelQueryPattern()}
          onEdit={
            queryPatternViewStore.isEditEnabled
              ? () => queryPatternViewStore.editQueryPattern()
              : undefined
          }
        />
        <ErrorDialog
          open={queryPatternViewStore.errorDialogOpened}
          title={queryPatternViewStore.errorTitle}
          description={queryPatternViewStore.errorDescription}
          onClose={() => queryPatternViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
